import LogsIcon from '@material-ui/icons/Assignment';
import LogsList from './components/LogsList';
import { roles, APP_TYPES } from '../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN],
  label: 'Logs',
  subMenuName: 'manage',
};

export default {
  list: LogsList,
  icon: LogsIcon,
  name: 'admin/logs',
  options,
};
